/*

    let nombre = req.body.nombre;
    let apellido = req.body.apellido;
    let username = req.body.username;
    let ci = req.body.ci;
    let tel = req.body.tel;
    let mail = req.body.mail;
    let tipo = req.body.tipo;
    let password = req.body.password;

*/

async function RegisterCliente(nombre, apellido, email, tel, password) {
    // 1. Detección de entorno
    const isLocal = window.location.hostname === "localhost" || window.location.port === "3000";

    // 2. Definimos la URL base y el endpoint correcto
    const BASE_URL = isLocal 
        ? 'http://localhost:4000' 
        : 'https://vetladradoc.uy';

    const URL_FINAL = `${BASE_URL}/api/auth/register`;

    console.log(`%c Intentando registro en: ${URL_FINAL} `, 'background: #222; color: #bada55; padding: 2px;');

    try {
        const response = await fetch(URL_FINAL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                nombre,
                apellido,
                email, // Usamos 'email' que es lo que espera tu body
                tel,
                password,
                tipo: 'c'
            })
        });

        // 3. Retornamos la respuesta del servidor (success, message, etc)
        return await response.json();

    } catch (error) {
        console.error("Error en la petición:", error);
        return { 
            success: false, 
            message: "Error de conexión: Verifica que el backend esté en el puerto 4000." 
        };
    }
}

export default RegisterCliente;